<template>
  <div class="search-texts">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Legislação</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-12">
          <div class="card search-card">
            <div class="title-search">Pesquisar</div>
            <div class="form-group">
              <label for>Palavras ou Trecho</label>
              <input type="text" v-model="filter.description" class="form-control" />
            </div>
            <div class="form-group">
              <label for>Nùmero/Ano</label>
              <input type="text" v-model="filter.number_law" class="form-control" />
            </div>
            <div class="form-group">
              <label for>Categoria</label>
              <multiselect
                v-model="categories"
                :multiple="true"
                :options="createParams.legislation_categories"
                selectLabel
                deselectLabel
                selectedLabel
                track-by="id"
                label="label_count"
                placeholder="Todas as categorias"
              ></multiselect>
            </div>
            <button
              class="btn btn-primary"
              style="height: 5vh"
              v-on:click="search()"
              :disabled="localLoading"
            >
              <b v-if="!localLoading">Pesquisar</b>
              <b-spinner type="grow" label="Spinning" v-if="localLoading"></b-spinner>
            </button>
            <button
              class="btn btn-secondary"
              style="margin-top: 12px"
              v-on:click="clearFilter()"
            >Limpar Filtros</button>
          </div>
        </div>
        <div class="col-lg-7 col-12 results-col">
          <div class="card total-data">{{rows}} Resultados</div>
          <div class="card news-card" v-for="item in data" v-bind:key="item.id">
            <router-link :to="{ name: 'client.legislation', params:{id: item.id} }">
              <div class="header-card-news">{{item.title}}</div>
              <div class="description-card">{{ limitText(item.ementa) }}</div>
              <div
                class="footer-card-news"
              >{{formatDate(item.publish_date ? item.publish_date : item.created_at)}}</div>
            </router-link>
          </div>
          <b-pagination
            v-if="data.length > 0"
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import helper from "@/imports/Helpers";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "search-texts",
  components: {
    Multiselect
  },
  data() {
    return {
      filter: {
        description: "",
        number_law: ""
      },
      createParams: {
        legislation_categories: []
      },
      categories: [],
      perPage: 5,
      currentPage: 1,
      rows: 0,
      data: [],
      localLoading: false
    };
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  mounted() {
    this.getCreateParams();
  },
  methods: {
    getCreateParams: function() {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/legislations_public/create`)
        .then(data => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
        });
    },
    mountSubIndices: function() {
      this.subindices_selected = [];
      this.indices.forEach(el => {
        el.sub_indices.forEach(subEl => {
          this.subindices_selected.push(subEl);
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.providerData();
    },
    clearFilter() {
      this.filter = {
        description: "",
        number_law: ""
      };
      this.categories = [];
    },
    providerData() {
      this.localLoading = true;
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/legislations_public?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
          this.localLoading = false;
        })
        .catch(error => {
          bus.$emit("changeLoading", false);
          this.localLoading = false;
          Swal.fire({
            title: "Ocorreu um erro.",
            text: "Verifique a sintaxe da pesquisa",
            icon: "error"
          });
        });
    },
    urlBuild: function() {
      let url =
        "sort=-id&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.categories.length > 0
          ? `&filter[legislation_category_id]=${this.generateFilterArray(
              this.categories
            )}`
          : "") +
        (this.filter.description
          ? `&filter[title]=${this.filter.description}`
          : "") +
        (this.filter.number_law
          ? `&filter[number_law]=${this.filter.number_law}`
          : "");

      return url;
    },
    generateFilterArray: function(array) {
      let filter = "";
      array.forEach((el, index) => {
        filter += el.id + (index < array.length - 1 ? "," : "");
      });
      return filter;
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    listAuthors: function(array) {
      let str = "";
      if (array) {
        array.forEach((el, index) => {
          str += el.name + (index < array.length - 1 ? ", " : " – ");
        });
      }
      return str;
    },
    limitText: function(text) {
      return helper.limitText(text, 185);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.search-texts {
  padding-bottom: 1.5vw;
  .info-icon {
    color: $red_primary;
    font-size: 20px;
  }
  .info-icon:hover {
    color: $red_primary_hover;
    cursor: pointer;
  }
  .info-icon:focus {
    outline: none;
  }
  .title-search {
    font-size: 20px;
    color: $red_primary;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .total-data {
    font-size: 18px;
    font-weight: bold;
    padding: 0.5vw 1vw;
  }
  .news-card {
    padding: 0.8vw 1vw 1.8vw 1vw;
    min-height: 130px;
    position: relative;
    .header-card-news {
      font-weight: bold;
    }
    .description-card {
      font-size: 14px;
      margin-bottom: 6px;
    }
    .footer-card-news {
      position: absolute;
      bottom: 0.8vw;
      margin-top: 9px;
      font-size: 12px;
      color: #5f6064;
    }
    a {
      text-decoration: none;
      color: #5f6064;
    }
    a:hover {
      color: black;
    }
  }
  .search-card {
    // height: 100%;
    // min-height: 80vh;
  }
  .results-col {
    position: relative;
    padding-bottom: 50px;
    // min-height: 85vh;
    .float-right {
      position: absolute;
      bottom: 0;
      right: 15px;
      margin-bottom: 0;
    }
  }
  .info-content {
    height: 75vh;
    overflow-y: auto;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>